import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ element }) => {
    const { isLoggedIn } = useSelector((state) => state.user);
    return isLoggedIn ? element : <Navigate to="/login" />;
};

export default PrivateRoute;
